import { PROPS } from './TableLoader.utils';
import TableResult from '@/components/Hoc/TableResult/TableResult';
import DotsLoader from './DotsLoader/DotsLoader';
import { useEffect, useState } from 'react';

export default function TableLoader({ label = 'Cargando...' }: PROPS) {
  // Local states
  const [activeDots, setActiveDots] = useState<string[]>(['1']);

  // Animate dots
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveDots((prevActiveDots) => {
        const lastDot = prevActiveDots[prevActiveDots.length - 1];
        const nextDot = lastDot === '3' ? '1' : String(Number(lastDot) + 1);
        return [...prevActiveDots.slice(1), nextDot];
      });
    }, 300);

    return () => clearInterval(interval);
  }, []);

  return (
    <TableResult>
      <DotsLoader label={label} activeDots={activeDots} />
    </TableResult>
  );
}
